<!--
UTPI中位数随孕周变化趋势、子痫前期患者UTPI分布点
-->
<template>
  <a-spin :spinning="loading">
    <div class="container" :style="{display: display}">
      <div style="background-color: #fff; padding: 12px 0">
        <div class="my-font-size-16 my-weight-500 titleBox" style="margin: 0 12px">
          <div class="my-primary-color">
            {{ chartName }} {{ markerName }} {{$t('home.median_change_trend')}}
          </div>
          <div>···</div>
        </div>
        <a-divider></a-divider>
        <div class="my-primary-margin">
          <div :id="idName" :class="className" :style="{ height: height, width: width }" />
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
import * as echarts from 'echarts'
// import ecStat from 'echarts-stat'
// require('echarts/theme/macarons') // echarts theme
// import resize from './mixins/resize'
export default {
  name: 'MarkPoint',
  components: {},
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    idName: {
      type: String,
      default: 'markPoint'
    },
    chartName: {
      type: String,
      default: 'chart'
    },
    markerName: {
      type: String,
      default: 'chart'
    },
    unit: {
      type: String,
      default: 'mmHg'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    allMarkerType: {
      type: Number,
      default: 0
    },
    itemType: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      chart: null,
      display: 'none',
      loading: false,
      chartData: {}
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    }
  },
  mounted () {
    this.getChartData()
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    getChartData () {
      this.loading = true
      let url = 'web/chartData/getPrePointData/'
      if (this.itemType === 0) {
        url = 'web/chartData/getPrePointData/'
      } else if (this.itemType === 1) {
        url = 'web/chartData/getDownsPointData/'
      } else if (this.itemType === 2) {
        url = 'web/chartData/getSgaPointData/'
      } else if (this.itemType === 3) {
        url = 'web/chartData/getFgrPointData/'
      }
      this.$get(url + this.allMarkerType).then((r) => {
        let data = r.data
        if (data.code === 200) {
          if (data.data) {
            this.chartData = data.data
            if (this.chartData.rightPointList && this.chartData.rightPointList.length > 10) {
              this.display = ''
            }
          }
          this.$forceUpdate()
        } else {
          this.$message.error(data.message)
        }
        this.loading = false
      })
    },
    initChart () {
      this.chart = echarts.init(document.getElementById(this.idName))
      this.setOptions(this.chartData)
    },
    setOptions ({ pointList, rightPointList } = {}) {
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {
          right: '20%',
          bottom: '10%'
        },
        xAxis: {
          name: 'GA/day',
          nameTextStyle: { fontSize: 13, color: '#000' },
          min: 'dataMin', // 默认取最大值显示
          max: 'dataMax', // 默认取最小值显示
          // 隐藏刻度
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#999999'
            }
          },
          axisLabel: {
            show: true,
            // 重点
            showMinLabel: true, // 显示x轴起始值
            showMaxLabel: true, // 显示x轴末尾值
            textStyle: { color: '#000', fontSize: 13 }
          }
        },
        yAxis: {
          name: this.markerName + '/' + this.unit,
          nameTextStyle: { fontSize: 13, color: '#000' },
          // 隐藏刻度
          axisTick: {
            show: false
          },
          // 隐藏轴线
          axisLine: {
            show: false
          },
          axisLabel: {
            textStyle: { color: '#000', fontSize: 13 }
          },
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        legend: {
          orient: 'vertical', // 'horizontal'
          top: 20,
          right: 5,
          data: [this.chartName + ' ' + this.$t('home.patient') + ' ' + this.markerName + ' ' + this.$t('home.distribution_point'), this.markerName + ' ' + this.$t('home.median_change_trend')]
        },
        series: [
          {
            name: this.chartName + ' ' + this.$t('home.patient') + ' ' + this.markerName + ' ' + this.$t('home.distribution_point'),
            type: 'scatter',
            data: pointList,
            itemStyle: {
              color: '#9192DA'
            }
          },
          {
            name: this.markerName + ' ' + this.$t('home.median_change_trend'),
            type: 'line',
            smooth: true,
            datasetIndex: 1,
            symbolSize: 0.1,
            symbol: 'circle',
            itemStyle: {
              color: '#1890FF',
              lineStyle: {
                color: '#1890FF',
                width: 3
              }
            },
            data: rightPointList
          }
        ]
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  margin-top: 12px
}

.header {
  width: 100%;
  background-color: #fff;
}
.ant-col {
  max-height: 60px !important;
}
.titleBox {
  padding-left: 20px;
  border-left: 4px solid #1890ff;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/manage/home/components/MarkPoint.vue